import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getApiUrl, sortAlphabeticallyObjects } from '../../utils';
import { Account } from '../global';

export type GetAccountResponse = Account[];
export type UpdateAccountPayload = {
  id: number;
  data: Omit<Account, 'id' | 'created_at' | 'updated_at'>;
};

const baseUrl = getApiUrl('accounts');

// Define a service using a base URL and expected endpoints
export const accounts = createApi({
  reducerPath: 'accountsApi',
  tagTypes: ['Accounts'],
  baseQuery: fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers, api) => {
      headers.set('x-api-key', process.env.REACT_APP_X_API_KEY);
      // headers.set('Content-Type', 'application/json')

      return headers;
    },
    credentials: 'include',
    mode: 'cors',
  }),
  endpoints: ({ query, mutation }) => ({
    getAllAccounts: query<GetAccountResponse, string>({
      query: () => '/',
      providesTags: ['Accounts'],
      transformResponse: (response: GetAccountResponse) => {
        return sortAlphabeticallyObjects(response, 'name');
      },
      forceRefetch: ({ currentArg, previousArg }) => {
        return true;
      },
    }),
    addAccount: mutation<Account, Partial<Account>>({
      query: (newAccount) => ({
        url: '/',
        method: 'POST',
        body: newAccount,
      }),
      invalidatesTags: ['Accounts'],
    }),
    editAccount: mutation<Account, UpdateAccountPayload>({
      query: (accountData) => ({
        url: `/${accountData.id}`,
        method: 'PATCH',
        body: accountData.data,
      }),
      invalidatesTags: ['Accounts'],
    }),
  }),
});

// TODO: https://stackoverflow.com/questions/61704805/getting-an-error-a-non-serializable-value-was-detected-in-the-state-when-using
// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetAllAccountsQuery,
  useAddAccountMutation,
  useEditAccountMutation,
} = accounts;
export const accountsApi = accounts.endpoints;
// export const resetAccountsApi = () => {
//   accounts.util.resetApiState()
// }
